import React from "react"

//components
import { BasicButton, BasicCheckbox, } from "thrive-components";
import TermsAndConditionsModal from "../../modals/TermsAndConditions/TermsAndConditionsModal";

//interfaces
import { ITermsAndConditions } from "../../../interfaces/FormInputs";


const TermsAndConditions = (
    {
        termsAndConditionsAgreed, 
        setTermsAndConditionsAgreed, 
        setShowTermsAndConditionsModal,
        showTermsAndConditionsModal,
        setHideTermsAndConditionsModal
    } : ITermsAndConditions
) => {

    return (
        <div className="terms-and-conditions-wrapper">
            <BasicCheckbox 
                id={"terms-and-conditions-checkbox"} 
                isChecked={termsAndConditionsAgreed} 
                onChange={() => setTermsAndConditionsAgreed(!termsAndConditionsAgreed)} 
                label={"I agree to the"}
            />
                        
            <BasicButton
                content={"Terms & Conditions"}    
                className="terms-and-conditions-button"
                ariaLabel="Terms & Conditions"
                onButtonClick={setShowTermsAndConditionsModal}
            />

            <TermsAndConditionsModal
                onAgreeClick={() => {
                    setTermsAndConditionsAgreed(true);
                    setHideTermsAndConditionsModal();
                }} 
                showModal={showTermsAndConditionsModal} 
                onHideModal={setHideTermsAndConditionsModal}
            />
        </div>
    )
}

export default TermsAndConditions